import { handleAjaxError } from "./handleAjaxError";
import { initMessageActions } from "../components/chatContent";
import { contentRenderedEvent } from "../events/contentRenderedEvent";
import { updateCredits } from "./updateCredits";
import { startVideoPolling } from "./asyncVideoPolling";

/**
 * Handle unlocking premium content in chat
 */
export function unlockContent() {
    $(document).on('submit', '.g-chatform-media-report-form', function (event) {
        event.preventDefault();
        const form = $(this);
        const button = form.find('button[type="submit"]');
        if (button.prop('disabled')) return;
        button.prop('disabled', true);
        $.ajax({
            url: growtype_chat_ajax.url, type: 'POST',
            data: {
                action: 'growtype_chat_report_media', nonce: growtype_chat_ajax.nonce,
                asset_key: form.find('[name="asset_key"]').val(),
                reason: form.find('[name="reason"]').val()
            }
        }).done(function (response) {
            form.find('[role="status"]').text(response.data.message);
            if (response.success) updateCredits(response.data.new_balance);
        }).fail(function () {
            form.find('[role="status"]').text('Could not save the request. Please retry.');
        }).always(function () { button.prop('disabled', false); });
    });
    $(document).on('click', '.btn-unlock-content', function (event) {
        event.preventDefault();

        let unlockBtn = $(this);
        const profileCard = unlockBtn.closest('.premium-post-card[data-profile-slug]');
        const profileSlug = profileCard.attr('data-profile-slug') || '';
        const retry = unlockBtn.attr('data-generation-poll') !== 'true';
        unlockBtn.removeAttr('data-generation-poll');
        let assetUrl = unlockBtn.attr('data-asset-url');
        let creditsCost = unlockBtn.attr('data-credits-cost');
        let messageId = unlockBtn.closest('.g-chatform-message').attr('data-id') || '';
        let sessionToken = unlockBtn.closest('.g-chatform').attr('data-session-token');
        let sessionId = unlockBtn.closest('.g-chatform-message').attr('data-session-id');

        if (unlockBtn.hasClass('is-loading') || unlockBtn.hasClass('is-disabled')) {
            console.warn("[Unlock] button already loading/disabled, ignoring click");
            return;
        }

        console.log("[Unlock] click: assetUrl=", assetUrl, "creditsCost=", creditsCost, "messageId=", messageId);

        unlockBtn.addClass('is-loading').attr('disabled', true);
        unlockBtn.append('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                action: profileSlug ? 'unlock_profile_content' : 'growtype_chat_unlock_content',
                profile_slug: profileSlug,
                asset_url: assetUrl,
                credits_cost: creditsCost,
                message_id: messageId,
                session_token: sessionToken,
                session_id: sessionId,
                nonce: growtype_chat_ajax.nonce,
                retry: retry ? 1 : 0,
            },
            success: function (response) {
                console.log("[Unlock] AJAX success:", response.success, response.data);
                if (response.success) {
                    if (response.data.generation_pending) {
                        const attempt = Number(unlockBtn.attr('data-generation-poll-attempt') || 0) + 1;
                        const delay = Math.min(15000, Math.round(1500 * Math.pow(1.4, Math.min(attempt, 7))));
                        unlockBtn.attr('data-generation-poll-attempt', attempt);
                        updateCredits(response.data.new_balance);
                        unlockBtn.find('.spinner-border').remove();
                        unlockBtn.attr('disabled', true);
                        if (attempt <= 80 && document.documentElement.contains(unlockBtn[0])) {
                            setTimeout(function () {
                                if (!document.documentElement.contains(unlockBtn[0])) return;
                                unlockBtn.attr('data-generation-poll', 'true').removeClass('is-loading').attr('disabled', false).trigger('click');
                            }, delay);
                        } else {
                            unlockBtn.removeClass('is-loading').attr('disabled', false).text('Still preparing — check again');
                            unlockBtn.removeAttr('data-generation-poll-attempt');
                        }
                        return;
                    }
                    if (response.data.generation_failed) {
                        unlockBtn.text('Generation failed — retry free').removeClass('is-loading');
                        unlockBtn.removeAttr('data-generation-poll-attempt');
                        unlockBtn.find('.spinner-border').remove();
                        unlockBtn.attr('disabled', false);
                        return;
                    }
                    unlockBtn.removeAttr('data-generation-poll-attempt');
                    // Trigger explosion animation
                    triggerUnlockExplosion(unlockBtn);

                    // Update credits display
                    updateCredits(response.data.new_balance);

                    if (profileSlug && response.data.profile_html) {
                        const newCard = $($.trim(response.data.profile_html));
                        profileCard.replaceWith(newCard);
                        document.dispatchEvent(contentRenderedEvent({
                            content: response.data.profile_html,
                            contentWrapper: newCard,
                            xp_added: 0
                        }));
                    }

                    if (response.data.html) {
                        // Find the message element to replace.
                        // We use the ID if available, otherwise fallback to the closest container.
                        let $target = $(`.g-chatform-message[data-id="${messageId}"]`);

                        if ($target.length === 0) {
                            $target = unlockBtn.closest('.g-chatform-message');
                        }

                        if ($target.length > 0) {
                            let $newHtml = $($.trim(response.data.html));

                            // Add a subtle fade-in effect to the new content
                            $newHtml.hide();

                            // Replace the old message with the new one
                            $target.replaceWith($newHtml);

                            $newHtml.fadeIn(400);
                            // A revealed purchase should load immediately. Lazy loading
                            // can leave the placeholder until another scroll after fade-in.
                            $newHtml.find('img.lazy-load[data-src]').each(function () {
                                const image = $(this);
                                image.attr('loading', 'eager');
                                if (image.attr('data-srcset')) {
                                    image.attr('srcset', image.attr('data-srcset')).removeAttr('data-srcset');
                                }
                                image.attr('src', image.attr('data-src')).removeAttr('data-src');
                            });

                            // Re-initialize actions for the new message content
                            initMessageActions($('.g-chatform'), $newHtml);

                            // Re-initialize any components if needed
                            document.dispatchEvent(contentRenderedEvent({
                                content: response.data.html,
                                contentWrapper: $newHtml,
                                xp_added: response.data.xp_added
                            }));

                            // If this was an async video unlock, start polling immediately.
                            // We can't rely on DOM scanning because the unlock button
                            // (data-asset-url="generate_pending") is no longer present.
                            const genId = response.data.generation_id || '';
                            console.log("[Unlock] generation_id from response:", genId || "(none)");
                            if (genId) {
                                const $msgEl = $newHtml.hasClass('g-chatform-message')
                                    ? $newHtml
                                    : $newHtml.find('.g-chatform-message').first();
                                console.log("[Unlock] $msgEl found:", $msgEl.length, "data-id:", $msgEl.attr('data-id'));
                                if ($msgEl.length) {
                                    startVideoPolling(genId, $msgEl);
                                } else {
                                    console.error("[Unlock] could not find .g-chatform-message in new HTML");
                                }
                            }
                        }
                    }

                    if (!response.data.html && response.data.asset_html) {
                        const $target = unlockBtn.closest('.image-wrapper');
                        if ($target.length) {
                            const $newHtml = $($.trim(response.data.asset_html));
                            $target.replaceWith($newHtml);
                        }
                    }

                    // Close fancybox if open
                    if ($.fancybox && $.fancybox.getInstance()) {
                        $.fancybox.close();
                    }
                } else {
                    console.error("[Unlock] AJAX response.success=false:", response);
                    handleAjaxError(response, unlockBtn);
                    unlockBtn.find('.spinner-border').remove();
                    unlockBtn.attr('disabled', false);
                }
            },
            error: function (xhr, status, err) {
                console.error("[Unlock] AJAX error:", status, err, xhr.responseText);
                handleAjaxError(xhr, unlockBtn);
                unlockBtn.find('.spinner-border').remove();
                unlockBtn.attr('disabled', false);
            },
            complete: function () {
                unlockBtn.removeClass('is-loading');
            }
        });
    });
}

/**
 * Trigger emoji explosion animation
 * @param {jQuery} $target 
 */
function triggerUnlockExplosion($target) {
    const explosionContainer = $('<div class="unlock-explosion-container"></div>').appendTo('body');
    const offset = $target.offset();
    const centerX = offset.left + $target.outerWidth() / 2;
    const centerY = offset.top + $target.outerHeight() / 2;

    const emojis = ['🔓', '✨', '⭐', '🔓', '🎉'];
    const particleCount = 15;

    for (let i = 0; i < particleCount; i++) {
        const emoji = emojis[Math.floor(Math.random() * emojis.length)];
        const $particle = $('<span class="explosion-particle">' + emoji + '</span>').appendTo(explosionContainer);

        const angle = Math.random() * Math.PI * 2;
        const velocity = 50 + Math.random() * 150;
        const tx = Math.cos(angle) * velocity;
        const ty = Math.sin(angle) * velocity - 100; // Upward bias

        $particle.css({
            position: 'absolute',
            left: centerX,
            top: centerY,
            fontSize: (20 + Math.random() * 16) + 'px',
            pointerEvents: 'none',
            zIndex: 999999,
            opacity: 1
        });

        $particle.animate({
            left: centerX + tx,
            top: centerY + ty,
            opacity: 0
        }, 1000 + Math.random() * 500, 'swing', function () {
            $(this).remove();
        });
    }

    setTimeout(() => {
        explosionContainer.remove();
    }, 2000);
}
